import Vue from "vue";
import App from "./App.vue";
import i18n from "./i18n";
import router from "./router";
import store from "./store";

import tzList from "./lists/tz";
import localeList from "./lists/locale";
import transfers from "./lists/transfers";
import printServer from "./lists/printServer";
import axios from "axios";

import Vuetify from "vuetify";
import "typeface-roboto/index.css";
import "vuetify/dist/vuetify.min.css";
import "@mdi/font/css/materialdesignicons.css";
import moment from "moment-timezone";
import ZoomOnHover from "vue-zoom-on-hover";

Vue.prototype.$http = axios;
Vue.prototype.$moment = moment;

Vue.prototype.$tzList = tzList;
Vue.prototype.$localeList = localeList;
Vue.prototype.$transfers = transfers;
Vue.prototype.$printServer = printServer;

Vue.config.productionTip = false;

Vue.use(ZoomOnHover);
Vue.use(Vuetify, {
  iconfont: 'md'
});

// Set Vuetify colors.
export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#008a95",
        primaryLigth: "#008a95",
        background: "#ffffff",
        loginBackground: "#e0e0e0",
      },
      dark: {
        primary: "#004349",
        primaryLigth: "#008a95",
        background: "#121212",
        loginBackground: "#0e0e0e",
      },
    },
    options: {
      customProperties: true,
    },
  }
});

let isFetchingToken = false;
let tokenSubscribers = [];

function subscribeTokenRefresh(cb) {
  tokenSubscribers.push(cb);
}

function onTokenRefreshed(errRefreshing, token) {
  tokenSubscribers.map((cb) => cb(errRefreshing, token));
}

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // If is not unauthorized reject.
    // !error.response => Connection error (net::ERR_CONNECTION_REFUSED)
    // error.response && error.response.status !== 401 => Error response
    if (!error.response || (error.response && error.response.status !== 401)) {
      return Promise.reject(error);
    }

    if (!isFetchingToken) {
      isFetchingToken = true;

      store
        .dispatch("refresh")
        .then((response) => {
          isFetchingToken = false;

          if (response.data.status == "success") {
            // Apply new token the requests.
            onTokenRefreshed(null, "Bearer " + response.data.access_token);
          } else {
            // If access_token or refresh_token are tampered, logout with error message.
            onTokenRefreshed(new Error(response.data.error), null);

            store
              .dispatch("logout", response.data.error)
              .then(() => router.push("/login"))
              .catch((err) => console.log(err));
          }

          tokenSubscribers = [];
        })
        .catch((err) => {
          // Catch conection error.
          onTokenRefreshed(new Error(err), null);
          tokenSubscribers = [];
        });
    }

    const initTokenSubscriber = new Promise((resolve, reject) => {
      subscribeTokenRefresh((errRefreshing, newToken) => {
        if (errRefreshing) return reject(errRefreshing);

        // Update header in failed requests.
        error.config.headers.Authorization = newToken;

        // Only try 5 times to get an authorization.
        if ("Retried-Times" in error.config.headers) {
          if (error.config.headers["Retried-Times"] >= 5) {
            return reject("Max retries getting a new token!");
          }

          error.config.headers["Retried-Times"] =
            error.config.headers["Retried-Times"] + 1;
        } else {
          error.config.headers["Retried-Times"] = 1;
        }

        return resolve(axios(error.config));
      });
    });

    return initTokenSubscriber;
  }
);

// Add access_token from localStorage when load the page.
if (store.getters.accessToken != "") {
  axios.defaults.headers.common = {
    Authorization: "Bearer " + store.getters.accessToken,
    Locale: store.getters.locale,
  };
}

new Vue({
  i18n,
  router,
  store,
  vuetify: new Vuetify(),
  render: (h) => h(App),
}).$mount("#app");
